/*
 * Products in same collection - PDP page
 *
 **/

custom.productsInCollection = (function () {
  function init() {
    //randomize order
    custom.utils.shuffle(collectionJson);
    //filter out color blankets & color blocks from "more from"
    var typesToFilter = ['COLOR BLANKET', 'COLOR BLOCK'];
    collectionJson = collectionJson.filter(function (el) {
      if (
        !el.title.includes(typesToFilter[0]) &&
        !el.title.includes(typesToFilter[1])
      )
        return el;
    });
    //remove current product and limit to 4 results
    collectionJson = collectionJson
      .filter(function (el) {
        return el.handle != collectionProduct;
      })
      .slice(0, 4);
    var collectionContainer = document.getElementById(
      'more-collection-container',
    );
    //matches found append content to section container
    collectionJson.forEach(function (item, index) {
      // filter out color blankets & color blocks from "more from"
      if (
        window.LoloiConfig.hide_collab.indexOf(item.named_tags.Collaboration) >=
        0
      )
        return;
      item.index = index + 1;
      item.product_type = item.type;
      item.image = item.featured_image;
      item.named_tags = {};
      item.named_tags.Discontinued =
        (item.tags.indexOf('Discontinued:boolean:True') ||
          item.tags.indexOf('Discontinued:boolean:TRUE')) >= 0
          ? 'True'
          : 'False';
      item.named_tags.Collection = collectionTitle;
      item.collection_handle = collectionHandle;
      item.collaboration_handle = collaborationHandle;
      item.named_tags.Collaboration = collaborationTitle;
      item.hideCollaboration =
        window.LoloiConfig.hide_collab.indexOf(collaborationTitle) >= 0;
      item.named_tags.Style = relatedStyle;

      item = custom.algoliaUtils.resultObjectReducer(item);

      item.hover_img = '';
      if (!window.touchDevice) {
        for (var i = 0; i < item.media.length; i++) {
          var image = item.media[i];
          if (!(typeof image.alt == 'undefined' || !image.alt)) {
            if (image.alt.toLowerCase() == 'hover') {
              item.hover_img = image.src.replace('.jpg', '_300x.jpg');
              break;
            }
          }
        }
      }

      collectionContainer.insertAdjacentHTML(
        'beforeend',
        window.productCardTemplate.render(item),
      );

      // if (!window.touchDevice) {
      //   custom.productCardHover.init();
      // }
      // Callbacks
    });
    custom.gtmHandler.init();
  }

  function updateCollectionPrices() {
    if ($('body').hasClass('authenticated')) {
      $('span[data-variant_id]').each(function () {
        //only update product card prices
        if ($(this).hasClass('product-card__price')) {
          const variantId = parseInt($(this).data('variant_id'));
          const newPrice = custom.utils.getVariantPriceById(variantId);
          const formatedPrice = slate.Currency.formatMoney(
            newPrice,
            '${{ amount_no_decimals }}',
          );
          $(this).removeClass('no-price');
          $(this).html(formatedPrice);
        }
      });
    }
  }
  return {
    init: init,
    updateCollectionPrices,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/products-in-collection.js